import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const EXCLUDE_BULK = [
    "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE",
    "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM",
];

const onBuildRestOverrides = (uri) => ({
    LIST: { url: `/${uri}` },
    CREATE: { url: `/${uri}` },
    UPDATE: { url: `/${uri}` },
    REMOVE: { url: `/${uri}` },
    DETAIL: { url: `/${uri}/:id` },
});

const PROJECTS = buildModuleApi({
    prefix: "PROJECTS", uri: "projects", withExtra: false, exclude: EXCLUDE_BULK,
    overrides: onBuildRestOverrides("projects"),
    extraActions: {
        DASHBOARD: { suffix: "/dashboard" },
        VERIFY_PIN: { suffix: "/:id/verify-pin" },
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const SUBPROJECTS = buildModuleApi({
    prefix: "SUBPROJECTS", uri: "subprojects", withExtra: false,
    exclude: [...EXCLUDE_BULK, "LIST"],
    overrides: onBuildRestOverrides("subprojects"),
    extraActions: {
        BY_PROJECT: { suffix: "/project/:projectId" },
        README: { suffix: "/:id/readme" },
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const ENVIRONMENTS = buildModuleApi({
    prefix: "ENVIRONMENTS", uri: "environments", withExtra: false,
    exclude: [...EXCLUDE_BULK, "LIST"],
    overrides: onBuildRestOverrides("environments"),
    extraActions: {
        BY_SUBPROJECT: { suffix: "/subproject/:subProjectId" },
        ARCHIVE_LIST: { suffix: "/archived/list" }, ARCHIVE_ONE: { suffix: "/:id/archive" }, RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const CREDENTIALS = buildModuleApi({
    prefix: "CREDENTIALS", uri: "credentials", withExtra: false,
    exclude: [...EXCLUDE_BULK, "LIST"],
    overrides: onBuildRestOverrides("credentials"),
    extraActions: {
        BY_PROJECT: { suffix: "/project/:projectId" },
        REVEAL: { suffix: "/:id/reveal" },
        EXPORT_ENV: { suffix: "/export" },
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
        FILE_ARCHIVE_LIST: { suffix: "/files/archived/list" },
        FILE_UPLOAD: { suffix: "/:id/files/upload" },
        FILE_DOWNLOAD: { suffix: "/files/:id/download" },
        FILE_ARCHIVE: { suffix: "/files/:id/archive" },
        FILE_RESTORE: { suffix: "/files/:id/restore" },
        FILE_REMOVE: { suffix: "/files" },
    },
});

const LOGBOOK = buildModuleApi({
    prefix: "LOGBOOK", uri: "logbook", withExtra: false, exclude: EXCLUDE_BULK,
    overrides: onBuildRestOverrides("logbook"),
    extraActions: {
        SEARCH: { suffix: "/search/:search" },
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const TODOS = buildModuleApi({
    prefix: "TODOS", uri: "todos", withExtra: false,
    exclude: [...EXCLUDE_BULK, "DETAIL"],
    overrides: onBuildRestOverrides("todos"),
    extraActions: {
        REORDER: { suffix: "/reorder" },
        ARCHIVE_LIST: { suffix: "/archived/list" }, ARCHIVE_ONE: { suffix: "/:id/archive" }, RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const CHANGES = buildModuleApi({
    prefix: "CHANGES", uri: "changes", withExtra: false, exclude: EXCLUDE_BULK,
    overrides: onBuildRestOverrides("changes"),
    extraActions: { ARCHIVE_LIST: { suffix: "/archived/list" }, ARCHIVE_ONE: { suffix: "/:id/archive" }, RESTORE_ONE: { suffix: "/:id/restore" } },
});

const DRAFTS = buildModuleApi({
    prefix: "DRAFTS", uri: "drafts", withExtra: false, exclude: EXCLUDE_BULK,
    overrides: onBuildRestOverrides("drafts"),
    extraActions: { ARCHIVE_LIST: { suffix: "/archived/list" }, ARCHIVE_ONE: { suffix: "/:id/archive" }, RESTORE_ONE: { suffix: "/:id/restore" } },
});

const DOCUMENTS = buildModuleApi({
    prefix: "DOCUMENTS", uri: "documents", withExtra: false,
    exclude: [...EXCLUDE_BULK, "LIST", "CREATE"],
    overrides: onBuildRestOverrides("documents"),
    extraActions: {
        UPLOAD: { suffix: "/upload" },
        UPLOAD_MULTIPLE: { suffix: "/upload-multiple" },
        BY_SUBPROJECT: { suffix: "/subproject/:subProjectId" },
        BY_LOGBOOK: { suffix: "/logbook/:logbookId" },
        CONTENT: { suffix: "/:id/content" },
        DOWNLOAD: { suffix: "/:id/download" },
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const LINKS = buildModuleApi({
    prefix: "LINKS", uri: "links", withExtra: false,
    exclude: [...EXCLUDE_BULK, "LIST", "DETAIL"],
    overrides: onBuildRestOverrides("links"),
    extraActions: {
        BY_PROJECT: { suffix: "/project/:projectId" },
        ARCHIVE_LIST: { suffix: "/archived/list" }, ARCHIVE_ONE: { suffix: "/:id/archive" }, RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const SNIPPETS = buildModuleApi({
    prefix: "SNIPPETS", uri: "snippets", withExtra: false,
    exclude: [...EXCLUDE_BULK, "LIST"],
    overrides: onBuildRestOverrides("snippets"),
    extraActions: {
        BY_SUBPROJECT: { suffix: "/subproject/:subProjectId" },
        ARCHIVE_LIST: { suffix: "/archived/list" }, ARCHIVE_ONE: { suffix: "/:id/archive" }, RESTORE_ONE: { suffix: "/:id/restore" },
    },
});


const STEP_GROUPS = buildModuleApi({
    prefix: "STEP_GROUPS", uri: "step-groups", withExtra: false,
    exclude: [...EXCLUDE_BULK, "LIST"],
    overrides: onBuildRestOverrides("step-groups"),
    extraActions: {
        BY_PROJECT: { suffix: "/project/:projectId" },
        BY_SUBPROJECT: { suffix: "/subproject/:subProjectId" },
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const STEPS = buildModuleApi({
    prefix: "STEPS", uri: "steps", withExtra: false,
    exclude: [...EXCLUDE_BULK, "LIST"],
    overrides: onBuildRestOverrides("steps"),
    extraActions: {
        BY_PROJECT: { suffix: "/project/:projectId" },
        BY_SUBPROJECT: { suffix: "/subproject/:subProjectId" },
        BY_GROUP: { suffix: "/group/:groupId" },
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});


const KANBAN_COLUMNS = buildModuleApi({
    prefix: "KANBAN_COLUMNS", uri: "kanban-columns", withExtra: false,
    exclude: [...EXCLUDE_BULK, "LIST", "DETAIL"],
    overrides: onBuildRestOverrides("kanban-columns"),
    extraActions: {
        BY_PROJECT: { suffix: "/project/:projectId" },
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const KANBAN_CARDS = buildModuleApi({
    prefix: "KANBAN_CARDS", uri: "kanban-cards", withExtra: false,
    exclude: [...EXCLUDE_BULK, "LIST", "DETAIL"],
    overrides: onBuildRestOverrides("kanban-cards"),
    extraActions: {
        BY_PROJECT: { suffix: "/project/:projectId" },
        BY_COLUMN: { suffix: "/column/:columnId" },
        FILES: { suffix: "/:id/files" },
        FILE_UPLOAD: { suffix: "/:id/files/upload" },
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const KANBAN_CARD_FILES = buildModuleApi({
    prefix: "KANBAN_CARD_FILES", uri: "kanban-card-files", withExtra: false,
    exclude: [...EXCLUDE_BULK, "LIST", "DETAIL", "CREATE", "UPDATE"],
    overrides: onBuildRestOverrides("kanban-card-files"),
    extraActions: {
        CONTENT: { suffix: "/:id/content" },
        DOWNLOAD: { suffix: "/:id/download" },
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const GUIDES = buildModuleApi({
    prefix: "GUIDES", uri: "guides", withExtra: false, exclude: EXCLUDE_BULK,
    overrides: {
        LIST: { url: "/guides" },
        CREATE: { url: "/guides" },
        UPDATE: { url: "/guides" },
        REMOVE: { url: "/guides" },
        DETAIL: { url: "/guides/:id" },
    },
    extraActions: {
        BY_PROJECT: { suffix: "/project/:projectId" },
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
        PAGE_CREATE: { suffix: "/:guideGroupId/pages" },
        PAGE_UPDATE: { suffix: "/pages" },
        PAGE_REMOVE: { suffix: "/pages" },
        PAGE_ARCHIVE_LIST: { suffix: "/pages/archived/list" },
        PAGE_ARCHIVE: { suffix: "/pages/:id/archive" },
        PAGE_RESTORE: { suffix: "/pages/:id/restore" },
        PAGE_DUPLICATE: { suffix: "/pages/:id/duplicate" },
    },
});

export const PROJECTS_CONSTANTS = PROJECTS.CONSTANTS;
export const SUBPROJECTS_CONSTANTS = SUBPROJECTS.CONSTANTS;
export const ENVIRONMENTS_CONSTANTS = ENVIRONMENTS.CONSTANTS;
export const CREDENTIALS_CONSTANTS = CREDENTIALS.CONSTANTS;
export const LOGBOOK_CONSTANTS = LOGBOOK.CONSTANTS;
export const TODOS_CONSTANTS = TODOS.CONSTANTS;
export const DRAFTS_CONSTANTS = DRAFTS.CONSTANTS;
export const CHANGES_CONSTANTS = CHANGES.CONSTANTS;
export const DOCUMENTS_CONSTANTS = DOCUMENTS.CONSTANTS;
export const LINKS_CONSTANTS = LINKS.CONSTANTS;
export const SNIPPETS_CONSTANTS = SNIPPETS.CONSTANTS;
export const GUIDES_CONSTANTS = GUIDES.CONSTANTS;
export const STEP_GROUPS_CONSTANTS = STEP_GROUPS.CONSTANTS;
export const STEPS_CONSTANTS = STEPS.CONSTANTS;
export const KANBAN_COLUMNS_CONSTANTS = KANBAN_COLUMNS.CONSTANTS;
export const KANBAN_CARDS_CONSTANTS = KANBAN_CARDS.CONSTANTS;
export const KANBAN_CARD_FILES_CONSTANTS = KANBAN_CARD_FILES.CONSTANTS;

export const PROJECTS_ENDPOINTS = {
    ...PROJECTS.ENDPOINTS,
    ...SUBPROJECTS.ENDPOINTS,
    ...ENVIRONMENTS.ENDPOINTS,
    ...CREDENTIALS.ENDPOINTS,
    ...LOGBOOK.ENDPOINTS,
    ...TODOS.ENDPOINTS,
    ...DRAFTS.ENDPOINTS,
    ...CHANGES.ENDPOINTS,
    ...DOCUMENTS.ENDPOINTS,
    ...LINKS.ENDPOINTS,
    ...SNIPPETS.ENDPOINTS,
    ...GUIDES.ENDPOINTS,
    ...STEP_GROUPS.ENDPOINTS,
    ...STEPS.ENDPOINTS,
    ...KANBAN_COLUMNS.ENDPOINTS,
    ...KANBAN_CARDS.ENDPOINTS,
    ...KANBAN_CARD_FILES.ENDPOINTS,
};
